import React from "react";

import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ArrowBackIosNewRounded } from "@mui/icons-material";
import PageHeader from "../../../../components/PageHeader";
import useAuth from "../../../../config/context/authContext";
import useFirebase from "../../../../config/context/firebaseContext";
import useMainState from "../../../../config/context/mainStateContext";
import useModal from "../../../../config/context/modalContext";
import { CafeteriaService } from "../../../../config/services/CafeteriaService";

export default function OrderSubTab() {
  const navigate = useNavigate();

  const { getConfig, analyticLog } = useFirebase();

  const { setShowSideMenuDrawer } = useMainState();
  const { currentUserState } = useAuth();
  const { pushAlert } = useModal();

  const CafeteriaList = CafeteriaService.List();

  const [loading, setLoading] = React.useState(false);

  const [tabShow, setTabShow] = React.useState("ru");

  React.useEffect(() => {}, []);

  React.useEffect(() => {}, []);

  return (
    <Box style={{ width: "100%" }}>
      <PageHeader
        title="Pedidos"
        leftIcon={<ArrowBackIosNewRounded />}
        onLeftAction={() => navigate("/home/menu")}
      />
    </Box>
  );
}
